import { useEffect, useState } from "react"
import { MdClose, MdDelete, MdDone, MdDoneOutline } from "react-icons/md"
import { RxPlusCircled } from "react-icons/rx"
import { secureAPICall } from "../utils/sessionUtils"
import { BACKEND_URI } from "../entries"
import { useNavigate } from "react-router-dom"
import logo from '../images/Mobile2Logo.svg';


export const TodosComponent = () => {

    const [activeTodoList, setActiveTodoList] = useState([])
    const [doneTodoList, setDoneTodoList] = useState([])
    const [permissionDenied, setPermissionDenied] = useState(false)

    const requestTodos = async ({ verbose = false }) => {
        return secureAPICall({ endpoint: BACKEND_URI + "/api/misc/fetch-todos", verbose: verbose })
    }

    useEffect(() => {
        requestTodos({})
            .then((data) => {
                setActiveTodoList(data.active_todos.sort((a, b) => b.timestamp - a.timestamp))
                setDoneTodoList(data.done_todos.sort((a, b) => b.timestamp - a.timestamp))
            })
            .catch((error) => {
                console.error(error.status, error.message)
                setPermissionDenied(true)
            })
    }, [])

    if (permissionDenied) {
        return <></>
    }

    return (
        <div className="flex w-full gap-2">
            <div className='flex flex-col items-center gap-2'>

                <p className='text-4xl text-violet-600'>TODO ({activeTodoList.length})</p>

                <div className="flex flex-col w-[500px] bg-inherit text-primary h-[700px] rounded-lg border p-1 gap-[2px] overflow-auto ">
                    <CreateTodo setActiveTodoList={setActiveTodoList} />

                    {
                        activeTodoList.map((todo, index) =>

                            <TodoElement key={todo.id} todo={todo} setActiveTodoList={setActiveTodoList} setDoneTodoList={setDoneTodoList} />
                        )
                    }
                </div>
            </div>
            <div className='flex flex-col items-center gap-2'>
                <p className='text-4xl text-violet-600'>DONE ({doneTodoList.length})</p>

                <div className="flex flex-col w-[500px] bg-inherit text-primary h-[700px] rounded-lg border p-1 gap-[2px] overflow-auto ">
                    {
                        doneTodoList.map((todo, index) =>

                            <TodoElement key={todo.id} todo={todo} setActiveTodoList={setActiveTodoList} setDoneTodoList={setDoneTodoList} />
                        )
                    }
                </div>
            </div>

        </div>
    )
}


const TodoElement = ({ todo, setActiveTodoList, setDoneTodoList }) => {

    const requestDeleteTodo = async ({ id, verbose = false }) => {
        const formData = new FormData()
        formData.append("id", id)
        return secureAPICall({ endpoint: BACKEND_URI + "/api/misc/delete-todo", body: formData, verbose: verbose })
    }

    const requestMarkTodo = async ({ id, done, verbose = false }) => {
        const formData = new FormData()
        formData.append("id", id)
        formData.append("done", done)
        return secureAPICall({ endpoint: BACKEND_URI + "/api/misc/mark-todo", body: formData, verbose: verbose })
    }

    const handleMark = () => {
        requestMarkTodo({ id: todo.id, done: !todo.done })
            .then((data) => {
                setActiveTodoList((prev) => {
                    let temp = prev.filter((a) => a.id !== todo.id)
                    if (data.todo.done) {
                        return [...temp]
                    }
                    return [data.todo, ...temp]
                })
                setDoneTodoList((prev) => {
                    let temp = prev.filter((a) => a.id !== todo.id)
                    if (data.todo.done) {
                        return [data.todo, ...temp]
                    }
                    return [...temp]
                })
            })
            .catch((error) => {
                console.error(error.status, error.message)
            })
    }

    const handleDelete = () => {
        requestDeleteTodo({ id: todo.id })
            .then(() => {
                setActiveTodoList((prev) => [...prev.filter((a) => a.id !== todo.id)])
                setDoneTodoList((prev) => [...prev.filter((a) => a.id !== todo.id)])
            })
            .catch((error) => {
                console.error(error.status, error.message)
            })
    }

    return (

        <div className="flex w-full group gap-3 rounded-lg border text-gray-200  odd:bg-inherit even:bg-[#343946] border-gray-400 items-center">
            <div className="w-8 px-2">
                <button className="btn btn-xs border border-gray-400 w-6 h-6 bg-inherit hover:bg-inherit text-white p-0" onClick={handleMark}>{todo.done ? <MdDoneOutline size={15} /> : ""}</button>
            </div>
            <div className="w-32 px-1 max-w-32 truncate bg-gray-700 flex items-center h-full">
                <span className="truncate w-full text-center">{todo.field}</span>
            </div>
            <div className="w-full px-1 py-2">
                <span className="text-wrap">{todo.content}</span>
            </div>
            <div className="hidden group-hover:flex px-1">
                <button className="hover:text-red-600" onClick={handleDelete}><MdDelete /></button>
            </div>
        </div>
    )
}


const CreateTodo = ({ setActiveTodoList }) => {

    const [field, setField] = useState("")
    const [content, setContent] = useState("")

    const [open, setOpen] = useState(false)

    const handleOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        setField("")
        setContent("")
    }


    useEffect(() => {
        const handleKeyPress = (event) => {
            let element1 = document.getElementById("create-todo-field")
            let element2 = document.getElementById("create-todo-content")
            if (element1 !== document.activeElement && element2 !== document.activeElement) {
                return null;
            }
            if (event.shiftKey) {

                if (event.key === 'Enter') {
                }
            }
            else if (event.key === 'Enter') {
                handleSubmit()
            }
        };
        document.addEventListener('keydown', handleKeyPress)
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [field, content])


    const requestCreateTodo = async ({ field, content, verbose = false }) => {
        const formData = new FormData()
        formData.append("field", field)
        formData.append("content", content)
        return secureAPICall({ endpoint: BACKEND_URI + "/api/misc/create-todo", body: formData, verbose: verbose })
    }

    const handleSubmit = () => {

        if (content.trim() === "") {
            return
        }

        requestCreateTodo({ field: field, content: content })
            .then((data) => {
                setActiveTodoList((prev) => [data.todo, ...prev])
                handleClose()

            })
            .catch((error) => {
                console.error(error.status, error.message)
                handleClose()
            })


    }

    return (
        open ?
            <div className="flex w-full  gap-3 rounded-lg border text-gray-200  odd:bg-inherit even:bg-[#343946] border-gray-400 items-center">
                <div className="w-8 px-2 flex flex-col gap-2">
                    <button className="btn btn-xs btn-square p-0 w-7 h-7 bg-inherit hover:bg-[#343946] text-green-600" onClick={handleSubmit}><MdDone size={20} /></button>
                    <button className="btn btn-xs btn-square p-0 w-7 h-7 bg-inherit hover:bg-[#343946] text-red-600" onClick={handleClose}><MdClose size={20} /></button>
                </div>
                <div className="w-32 px-1 max-w-32 truncate bg-sky-800 flex items-center justify-center h-full">
                    <input type="text" id="create-todo-field" className="input input-sm bg-[#343946] px-1 m-0 w-[85px] text-inherit" value={field} placeholder="Field" onChange={(e) => setField(e.target.value)} />
                </div>
                <div className="w-full px-1 py-2">
                    <textarea id="create-todo-content" className="textarea w-full bg-[#343946] text-inherit m-0" placeholder="TODO" value={content} onChange={(e) => setContent(e.target.value)} />
                </div>
            </div>
            :
            <div className="flex w-full justify-center bg-inherit mb-2">
                <button
                    className="btn w-full btn-md h-9 p-0 text-primary bg-inherit hover:text-white hover:bg-primary  "
                    onClick={handleOpen}
                >
                    <RxPlusCircled size={30} />
                </button>
            </div>
    )
}


export const RoutesProgress = () => {
    const navigator = useNavigate()

    return (
        <div className='flex flex-col'>
            <img src={logo} className="w-64" alt="logo" />
            <div className='flex flex-col gap-3 justify-center items-start text-base'>
                <p className='text-4xl text-violet-600'>Routes</p>
                <div className='flex gap-3'>
                    <p className='text-green-600'>DONE</p>
                    <a className='cursor-pointer underline' onClick={() => { }}>ticket/[ticket_info]</a>
                </div>
                <div className='flex gap-3'>
                    <p className='text-green-600'>DONE</p>
                    <a className='cursor-pointer underline' onClick={() => { }}>admin/[ticket_id]/edit</a>
                </div>
                <div className='flex gap-3'>
                    <p className='text-green-600'>DONE</p>
                    <a className='cursor-pointer underline' onClick={() => { navigator("admin/notifications") }}>admin/notifications</a>
                </div>
                <div className='flex gap-3'>
                    <p className='text-green-600'>DONE</p>
                    <a className='cursor-pointer underline' onClick={() => { navigator("admin/ticket") }}>admin/ticket</a>
                </div>
                <div className='flex gap-3'>
                    <p className='text-green-600'>DONE</p>
                    <a className='cursor-pointer underline' onClick={() => { navigator("create-ticket") }}>create-ticket</a>
                </div>
                <div className='flex gap-3'>
                    <p className='text-green-600'>DONE</p>
                    <a className='cursor-pointer underline' onClick={() => { navigator("admin/setup") }}>admin/setup</a>
                </div>
                <div className='flex gap-3'>
                    <p className='text-green-600'>DONE</p>
                    <a className='cursor-pointer underline' onClick={() => { navigator("admin/settings") }}>admin/settings</a>
                </div>
                <div className='flex gap-3'>
                    <p className='text-green-600'>DONE</p>
                    <a className='cursor-pointer underline' onClick={() => { navigator("admin/users") }}>admin/users</a>
                </div>
                <div className='flex gap-3'>
                    <p className='text-green-600'>DONE</p>
                    <a className='cursor-pointer underline' onClick={() => { navigator("search-ticket") }}>search-ticket</a>
                </div>
                <div className='flex gap-3'>
                    <p className='text-green-600'>DONE</p>
                    <a className='cursor-pointer underline' onClick={() => { navigator("login") }}>login</a>
                </div>
                <div className='flex gap-3'>
                    <p className='text-green-600'>DONE</p>
                    <a className='cursor-pointer underline' onClick={() => { navigator("setup-password") }}>setup-password</a>
                </div>
                <div className='flex gap-3'>
                    <p className='text-green-600'>DONE</p>
                    <a className='cursor-pointer underline' onClick={() => { navigator("admin/dashboard") }}>admin/dashboard</a>
                </div>
            </div>
        </div>
    )
}